<template>
    <div>
        <div class="form-group" :class="{'has-error': validation.hasError('modelo.telefono')}" style="margin-bottom:0">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> <span class="text-danger">*</span> Telefono</div>
            <input type="text" v-model.trim="modelo.telefono" class="form-control" placeholder="Ingrese solo digitos">
          </div>
          <div class="error" v-if="validation.hasError('modelo.telefono')"> {{validation.firstError('modelo.telefono')}} </div>
        </div>
        
        <p class="text-primary" style="margin-top:0"> <small>{{msg}}</small> </p>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,validation:Object,default:{type:String,required:false,default:null} },
    data () { 
        return {
          isLoading: false,
            timeoutHnd: 0,
            msg:'',
            modelo: {
              telefono: null,
            }
        }
    },
    watch:{
      'modelo.telefono': function(){
        this.model.telefono=this.modelo.telefono;
        this.msg = "Verificando contacto...";
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var query = this.model.telefono;
        var vue = this;
        this.timeoutHnd = setTimeout(function () {
          query = query.trim();
          if(query.length>2) {
            //vue.isLoading = true;
            vue.asyncFind(query);
          }else{
            this.msg = "";
          }
          this.timeoutHnd = 0;
        }, 800);      
      },
      'default':function(a){
        if( a == null ) return;
        this.modelo.telefono = a;
      },
    },
    methods: {
        async asyncFind (query) {
            //if( query.length <= 3 ) return;
            if( this.isLoading ) return;
            this.isLoading = true
            var vue = this;
            var sql = gql`query{ getContactoByPhone(telefono:"${query}"){ asesor{id,nombres,pri_apellido,seg_apellido} fecha_registro} }`;
            window.console.log( sql );
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
              vue.isLoading = false;
              if( data.data == null ){
                vue.msg = "Error, inicie session nuevamente";
                return;
              }
              if( data.data.getContactoByPhone ){
                var u = data.data.getContactoByPhone.asesor;
                var n = u.nombres+" "+u.pri_apellido;
                if( u.seg_apellido ) n += " "+u.seg_apellido;
                this.$emit('eventBack', {ifExist: true, fecha: data.data.getContactoByPhone.fecha_registro})
                vue.msg = "Este contacto fue registrado la ultima vez por: " +n+ ' en fecha : ' + data.data.getContactoByPhone.fecha_registro
              }else{
                vue.msg = ""
                this.$emit('eventBack', {ifExist: false, fecha: null})
              }
              
            }).catch((error) => {
                window.console.error(error)
                vue.isLoading = false;
                vue.msg = "...";
                vue.$notify( parseJsonError( error,'getContactoByPhone' ) )
            })
        },
        clearAll () {
            this.modelo.intereses = null;
        },
    },
    mounted(){
        
    }
}
</script>